import { render, staticRenderFns } from "./attach-policy.vue?vue&type=template&id=23e592af&scoped=true&"
import script from "./attach-policy.vue?vue&type=script&lang=js&"
export * from "./attach-policy.vue?vue&type=script&lang=js&"
import style0 from "./attach-policy.vue?vue&type=style&index=0&id=23e592af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e592af",
  null
  
)

export default component.exports